import React from "react";
import { Helmet } from "react-helmet";
import { teamImg1, teamImg2, teamImg3, teamImg4, teamImg7, teamImg8, teamImg9 } from "../../assets/img";
import BlogSlider from "../../components/BlogSlider/BlogSlider";
import CmSlider from "../../components/CmSlider/CmSlider";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Hero from "../../components/Hero/Hero";
import TechList from "../../components/TechList/TechList";
import "./AboutPage.css";


function AboutPage() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>About | TechFreelanceX</title>
        <meta name="description" content="TechFreelanceX is group of independent professionals who will to  work on technology projects on a freelance basis." />
      </Helmet>
      <Header />
      <Hero animateText={false} text1="We are" text2="TechFreelanceX." />

      <section className="text_block ">
        <div className="text_block_inner container">
          <div className="col-1">
            <p><u><b>TechFreelanceX</b></u> is group of independent professionals who will to  work on technology projects on a freelance basis. Our teams are made up of individuals who possess a wide range of skills & experience in various areas of technologies, such as <em>software development, web development, mobile app development, and digital marketing.</em> </p>
          </div>
        </div>
      </section >
      <section className="about-row-2 spacing text_block">
        <div className="text_block_inner container">
          <div className="col-1">
            <h4>Why we ?</h4>
            <p> One of the advantages of working with us is, <em> as a freelancer we're not individuals, but a teams of experts with multiple skillsets and experience in the technology stack which we use.</em></p>
            <p>👉 We all are experienced Professionals.</p>
            <p>👉 We have always a backup resource.</p>
          </div>
        </div>
      </section>



      <div className="all-team spacing">
        <div className="container all-team-inner">
          <div className="heading">
            <h4>Meet my team members</h4>
          </div>
          <div className="all-team">
            <div className="inner">
              <div className="t-item ">
                <div className="img-wrap">
                  <img src={teamImg4} alt="Nandini" />
                  <div className="overlay">
                    <p>Capable, communicative, cheerful.</p>
                    <p className="cambon_font">and fearless.</p>
                  </div>
                </div>
                <h6>Nandini </h6>
                <p className="cambon_font">Frontend Developer</p>
              </div>


              <div className="t-item ">
                <div className="img-wrap">
                  <img src={teamImg2} alt="Kuldeep" />
                  <div className="overlay">
                    <p>Multipurpose tech mind </p>
                    <p className="cambon_font">with attractive nature.</p>
                  </div>
                </div>
                <h6>Kuldeep </h6>
                <p className="cambon_font">Frontend Developer</p>
              </div>
              <div className="t-item ">
                <div className="img-wrap">
                  <img src={teamImg1} alt="Rahul Lodhi" />
                  <div className="overlay">
                    <p>Exploring & Learning </p>
                    <p className="cambon_font">new Technologies.</p>
                  </div>
                </div>
                <h6>Rahul Lodhi</h6>
                <p className="cambon_font">Full Stack Developer</p>
              </div>
              <div className="t-item ">
                <div className="img-wrap">
                  <img src={teamImg3} alt="Neeraj" />
                  <div className="overlay">
                    <p>Silent backend </p>
                    <p className="cambon_font">code artist.</p>
                  </div>
                </div>
                <h6>Neeraj</h6>
                <p className="cambon_font">Backend Developer</p>
              </div>
              <div className="t-item ">
                <div className="img-wrap">
                  <img src={teamImg8} alt="Sachin" />
                  <div className="overlay">
                    <p>Fully stacked and packed</p>
                    <p className="cambon_font">with skills.</p>
                  </div>
                </div>
                <h6>Sachin</h6>
                <p className="cambon_font">App Developer(Fullstack)</p>
              </div>
              <div className="t-item ">
                <div className="img-wrap">
                  <img src={teamImg7} alt="Mohit" />
                  <div className="overlay">
                    <p>Creativity mind </p>
                    <p className="cambon_font">but only in night.</p>
                  </div>
                </div>
                <h6>Mohit</h6>
                <p className="cambon_font">UX Designer</p>
              </div>
              <div className="t-item ">
                <div className="img-wrap">
                  <img src={teamImg9} alt="Chandini" />
                  <div className="overlay">
                    <p>Connecting us </p>
                    <p className="cambon_font">
                      to outside the world and create opportunities.
                    </p>
                  </div>
                </div>
                <h6>Chandini</h6>
                <p className="cambon_font">Digital Marketing Expert</p>
              </div>


              <div className="t-item  job-card ">
                <div class="s_item_inner">
                  <div>
                    <h5>Jobs</h5>
                  </div>
                  <h4>Space for your skill</h4>
                  {/* <h6>
                    Job finder ?
                  </h6> */}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TechList />
      <CmSlider />
      <BlogSlider />
      <Footer />
    </>
  );
}

export default AboutPage;
